import { useTranslation } from 'react-i18next';
import interiorIcon from 'public/static/images/vdp/interior.svg';
import exteriorIcon from 'public/static/images/vdp/exterior.svg';
import safetyIcon from 'public/static/images/vdp/safety.svg';
import otherIcon from 'public/static/images/vdp/other-features.svg';
import moreIcon from 'public/static/images/vdp/more-features.svg';
import { screen } from 'components/styles/variables';
import css from 'styled-jsx/css';
import { useState, useContext } from 'react';
import useEvents from 'lib/hooks/useEvents';
import tapEvent from 'lib/Tracking/Vdp/KeyFeatures/TapEvent';
import VdpEventContext from 'contexts/VdpEventContext';
import LinkButton from 'components/Shared/LinkButton';
import FeatureGroup from './FeatureGroup';
import styles from './styles';
import { KeyFeaturesViewModel } from './types';

const featureGroupStyles = css.resolve`
  .margin {
    margin-bottom: 24px;
  }

  @media screen and (min-width: ${screen.mdMin}) {
    .margin {
      margin-bottom: 28px;
    }
  }
`;

const KeyFeatures = ({
  interior,
  exterior,
  safety,
  other,
  more,
}: KeyFeaturesViewModel): JSX.Element => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const marginClassName = `${featureGroupStyles.className} margin`;
  const buttonText = expanded ? t('vdp.showLess') : t('vdp.showMore');
  const logger = useEvents();
  const { trackingParams } = useContext(VdpEventContext);

  function onMoreClick(): void {
    logger.log(tapEvent({ isExpanded: expanded, trackingParams }));
    setExpanded(!expanded);
  }

  return (
    <div className="key-features">
      <div className="title">{t('vdp.keyFeatures')}</div>
      <div className="feature-groups-container">
        {interior.length > 0 && (
          <div className="right-features">
            <FeatureGroup icon={interiorIcon} title={t('vdp.interior')} features={interior} />
          </div>
        )}
        <div className="left-features">
          {exterior.length > 0 && (
            <FeatureGroup
              icon={exteriorIcon}
              title={t('vdp.exterior')}
              features={exterior}
              className={marginClassName}
            />
          )}
          {safety.length > 0 && (
            <FeatureGroup
              icon={safetyIcon}
              title={t('vdp.safety')}
              features={safety}
              className={marginClassName}
            />
          )}
          {other.length > 0 && (
            <FeatureGroup icon={otherIcon} title={t('vdp.other')} features={other} />
          )}
        </div>
      </div>
      {expanded && more.length > 0 && (
        <div className="more-features">
          <FeatureGroup
            icon={moreIcon}
            title={t('vdp.moreFeatures')}
            features={more}
            twoColumns={true}
          />
        </div>
      )}
      {more.length > 0 && (
        <LinkButton className="link-button" onClick={onMoreClick}>
          {buttonText}
        </LinkButton>
      )}
      {featureGroupStyles.styles}
      <style jsx>{styles}</style>
    </div>
  );
};

export default KeyFeatures;
